import 'css-chunk:src/event-selection/EventGroup.module.scss';export default {
  "eventGroup": "_eventGroup_1044l_1",
  "panel": "_panel_1044l_9",
  "expanded": "_expanded_1044l_16"
};